import {ButtonStyle} from 'ui-library/buttons/Button';
import * as modals from 'util/Modals';

import {BlockEditorUIState} from './reduceBlockEditorUIs';

export default async function runConfirmOpenDashboardModal(
  blockEditorUIState: BlockEditorUIState
): Promise<boolean> {
  const isSQLTemplate = blockEditorUIState.sqlTemplateFormState != null;
  const confirmationTitle = isSQLTemplate ? 'Discard changes?' : 'Discard query?';

  const confirmationText = isSQLTemplate
    ? `Your query hasn’t been run, so you will lose any changes you’ve made to the template. Do you want to discard your changes?`
    : `Your query hasn’t been run, so you will lose any progress you’ve made. Do you want to discard your query?`;

  return (await Promise.resolve(
    modals.confirm(confirmationTitle, confirmationText, ButtonStyle.NEGATIVE, {
      acceptText: 'Discard',
      rejectText: 'Cancel',
      enableRedesign: true,
      promiseCompatible: true,
    })
  )) as boolean;
}
